import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-letter",
  "use": "icon-letter-usage",
  "viewBox": "0 0 56.22 37.04",
  "content": "<symbol viewBox=\"0 0 56.22 37.04\" id=\"icon-letter\">\r\n    <path d=\"M55.7,1.9A3.84,3.84,0,0,0,52.39,0H3.82A3.81,3.81,0,0,0,2.2.36a3.67,3.67,0,0,0-1,.73A3.8,3.8,0,0,0,0,3.82v29.4A3.83,3.83,0,0,0,3.82,37H52.39a3.83,3.83,0,0,0,1.9-.51,3.89,3.89,0,0,0,1.46-1.47,3.84,3.84,0,0,0,.47-1.84V3.82A3.78,3.78,0,0,0,55.7,1.9Zm-3.42,0L28.11,20.15,4.22,1.91ZM2.16,34.16a1.83,1.83,0,0,1-.25-.94V3.82a1.82,1.82,0,0,1,.23-.9l16,12.18Zm50.23,1H4L19.73,16.36l8.37,6.39,9-6.8L53,35A2,2,0,0,1,52.39,35.13Zm1.91-1.91a.28.28,0,0,1,0,.09L38.74,14.71,54.15,3.08a1.85,1.85,0,0,1,.15.74Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/letter.svg
// module id = BFzH
// module chunks = 0